import { Provider } from 'react-redux';
import { Suspense, useEffect } from 'react';
import AppRouter from 'src/routes/index';
import store from 'src/redux';
import AppSnackbarProvider from './components/appSnackbarProvider';
import Loader from './components/Loader';
import { AppThemeProvider } from './assets/theme/ThemeContext';
import { rememberExtension } from './helpers/extensionBridge';

function App() {
  // Any Abekus page the extension stamps counts as this browser having it.
  useEffect(() => rememberExtension(), []);

  return (
    <Provider store={store}>
      <AppThemeProvider>
        <AppSnackbarProvider />
        <Suspense fallback={<Loader />}>
          <AppRouter />
        </Suspense>
      </AppThemeProvider>
    </Provider>
  );
}

export default App;
